import { IConversation, IUser } from "./modal";
import { format, isThisWeek, isThisYear, isToday, isYesterday } from "date-fns";
import { hrLenseBaseUrl } from "../../shared/Fetch";
import profilePic from "../../assets/Images/profile_pic_placeholder.jpg";
import { Badge } from "primereact/badge";
import tekLenseLogo from "../../assets/Images/tekLenseLogo.png";
import { AutoComplete } from "primereact/autocomplete";
import { useState } from "react";
import { useNotification } from "../../shared/NotificatonContext";

export function formatLastMessageDateTime(dateString: string) {
    if (dateString === '') return dateString;
    const date = dateString.includes('Z') ? new Date(dateString) : new Date(dateString + "Z");
    if (isToday(date)) return format(date, "h:mm a");
    if (isThisYear(date)) return format(date, "MM/dd");
    return format(date, "MM/dd/yyyy");
}
export function formatChatSepratorDate(dateString: string) {
    if (dateString === '') return dateString;
    const date = dateString.includes('Z') ? new Date(dateString) : new Date(dateString + "Z");
    if (isToday(date)) return "Today";
    if (isYesterday(date)) return "Yesterday";
    if (isThisWeek(date, { weekStartsOn: 1 })) return format(date, "EEEE");
    return format(date, "MMMM dd, yyyy");
}
export function formatMessageTime(dateString: string) {
    if (dateString === '') return dateString;
    const date = dateString.includes('Z') ? new Date(dateString) : new Date(dateString + "Z");
    return format(date, "h:mm a");
}

export default function JVConversations({
    conversations,
    currentConversationId,
    onSelectConversationId,
    onUserSelect,
}: {
    conversations?: IConversation[];
    currentConversationId?: number;
    onSelectConversationId: (conversationId: number) => void;
    onUserSelect: (user: IUser) => void;
}) {
    const [value, setValue] = useState('');
    const [options, setOptions] = useState<IUser[]>();
    const { searchUsers, isOnline } = useNotification();

    const userOptionTemplate = (user: IUser) => {
        return (
            <div style={styles.userItem}>
                <div style={styles.avatar}>
                    {user.employeeId
                        ? <img src={`${hrLenseBaseUrl}/Hrlense_Employee/getEmployeeImages?EmployeeCode=${user.employeeId}`}
                            onError={e => e.currentTarget.src = profilePic}
                            style={styles.avatarImg} loading="lazy" />
                        : user.name.charAt(0).toUpperCase()}
                </div>
                <div style={{ flex: 1 }}>
                    <div style={styles.name}>{user.name}</div>
                    <div style={styles.email}>{user.email}</div>
                    <div style={styles.company}>{user.companyName} | {user.branchName}</div>
                </div>
            </div>
        );
    };

    return (
        <div style={styles.sidebar}>
            <div style={styles.header}>
                <AutoComplete suggestions={options}
                    value={value} onChange={(e) => typeof (e.value) === 'string' ? setValue(e.value) : setValue('')}
                    completeMethod={(event) => setOptions(searchUsers(event.query))}
                    placeholder="Search User"
                    itemTemplate={userOptionTemplate}
                    className="w-full"
                    onSelect={(e) => onUserSelect(e.value)} />
            </div>

            <div style={styles.userList}>
                {!conversations && <div className="text-center">Loading...</div>}
                {conversations?.map(cvsn => {
                    const isActive = currentConversationId === cvsn.id;
                    if (cvsn.isGroup) {
                        const groupName = cvsn.groupName!;
                        return (
                            <div
                                key={cvsn.id}
                                onClick={() => onSelectConversationId(cvsn.id)}
                                style={{
                                    ...styles.userItem,
                                    backgroundColor: isActive ? "#e9f2ff" : "white"
                                }}
                            >
                                <div style={styles.groupAvatar}>
                                    {groupName === 'Global Chat'
                                        ? <img src={tekLenseLogo}
                                            style={styles.avatarImg} />
                                        : groupName.charAt(0).toUpperCase()}
                                </div>

                                <div style={{ flex: 1 }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div style={styles.name}>{groupName}</div>
                                        <div style={{ ...styles.lastMessageTime, fontWeight: cvsn.unreadCount > 0 ? 'bold' : 'normal' }}>{formatLastMessageDateTime(cvsn.lastMessageTime)}</div>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div style={{ ...styles.lastMessage, fontWeight: cvsn.unreadCount > 0 ? 'bold' : 'normal' }}>{cvsn.lastMessage}</div>
                                        <div>
                                            {cvsn.unreadCount > 0 && <Badge value={cvsn.unreadCount} />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    } else {
                        const userId = cvsn.userId;
                        const user = cvsn.user;
                        const lastMessage = cvsn.lastMessage.replace('<req>', '').replace('<pip>', '').replace('<eci>', '')
                            .replace('</req>', '\n').replace('</pip>', '\n').replace('</eci>', '\n');
                        return (
                            <div
                                key={cvsn.id}
                                onClick={() => onSelectConversationId(cvsn.id)}
                                style={{
                                    ...styles.userItem,
                                    backgroundColor: isActive ? "#e9f2ff" : "white"
                                }}
                            >
                                <div style={styles.avatar}>
                                    {user?.employeeId
                                        ? <img src={`${hrLenseBaseUrl}/Hrlense_Employee/getEmployeeImages?EmployeeCode=${user.employeeId}`}
                                            onError={e => e.currentTarget.src = profilePic}
                                            style={styles.avatarImg} loading="lazy" />
                                        : user?.name.charAt(0).toUpperCase()}
                                    {(userId && isOnline(userId)) && (<span style={styles.onlineDot}></span>)}
                                </div>

                                <div style={{ flex: 1 }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div style={styles.name}>{user?.name}</div>
                                        <div style={{ ...styles.lastMessageTime, fontWeight: cvsn.unreadCount > 0 ? 'bold' : 'normal' }}>{formatLastMessageDateTime(cvsn.lastMessageTime)}</div>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div style={{ ...styles.lastMessage, fontWeight: cvsn.unreadCount > 0 ? 'bold' : 'normal' }}>{lastMessage}</div>
                                        <div>
                                            {cvsn.unreadCount > 0 && <Badge value={cvsn.unreadCount} />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    }
                })}
            </div>
        </div>
    );
}

const styles: Record<string, React.CSSProperties> = {
    sidebar: {
        width: "300px",
        borderRight: "1px solid #ddd",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "white"
    },
    header: {
        padding: "20px",
        fontWeight: 600,
        fontSize: 18,
        borderBottom: "1px solid #eee"
    },
    userList: {
        overflowY: "auto",
        flex: 1
    },
    userItem: {
        display: "flex",
        alignItems: "center",
        padding: "15px",
        cursor: "pointer",
        borderBottom: "1px solid #f1f1f1",
        transition: "0.2s"
    },
    avatar: {
        width: 45,
        minWidth: 45,
        height: 45,
        borderRadius: "50%",
        backgroundColor: "#4e73df",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 600,
        marginRight: 10,
        position: 'relative',
    },
    groupAvatar: {
        width: 45,
        minWidth: 45,
        height: 45,
        borderRadius: "50%",
        backgroundColor: "#28c76f",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 600,
        marginRight: 10,
        position: 'relative',
    },
    onlineDot: {
        position: "absolute",
        bottom: 2,
        right: 2,
        width: 10,
        height: 10,
        borderRadius: "50%",
        backgroundColor: "#22c55e",
        border: "2px solid white"
    },
    avatarImg: {
        width: "100%",
        height: "100%",
        borderRadius: "50%",
        objectFit: "cover"
    },
    name: {
        fontWeight: 600,
        display: "-webkit-box",
        WebkitLineClamp: 1,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
    },
    lastMessage: {
        fontSize: 12,
        color: "gray",
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        wordBreak: "break-word",
        overflowWrap: "break-word",
        whiteSpace: "pre-wrap"
    },
    lastMessageTime: {
        fontSize: 10,
        color: "gray",
    },
    unreadCount: {
        backgroundColor: 'orange',
        fontWeight: 'bold',
        padding: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        fontSize: 12,
        minWidth: 16,
    },
    email: {
        fontSize: 12,
        color: "gray",
        textOverflow: 'ellipsis'
    },
    company: {
        fontSize: 12,
        color: "gray",
        textOverflow: 'ellipsis',
    },
};